/* eslint-disable */
/* eslint-disable eslint-comments/no-unused-disable */
/* 
* The file is automatically generated by Serenity UI.
* 
* ⚠️ WARNING: Any manual changes may be overwritten during the next upgrade
* 
* Found an issue? Submit a task to the ClickUp board:
* https://app.clickup.com/1255586/v/l/6-901510012553-1?pr=90154030902
*/
import * as stylex from '@stylexjs/stylex';
import { type ForwardedRef, createContext, forwardRef } from 'react';
import { Breadcrumb as BreadcrumbCore, type BreadcrumbProps as BreadcrumbCoreProps, type ContextValue, Provider, useContextProps } from 'react-aria-components';
import { $ } from '../../tokens.stylex';
import { LinkContext } from '../link/link.component';
import { Text, TextContext } from '../text/text.component';

interface BreadcrumbProps extends Omit<BreadcrumbCoreProps, 'style' | 'className'> {
  style?: stylex.StyleXStyles;
}

const BreadcrumbContext = createContext<ContextValue<BreadcrumbProps, HTMLLIElement>>({});

const Breadcrumb = forwardRef((props: BreadcrumbProps, ref: ForwardedRef<HTMLLIElement>) => {
  [props, ref] = useContextProps(props, ref, BreadcrumbContext);

  const { style, children, ...coreProps } = props;

  return (
    <BreadcrumbCore ref={ref} {...stylex.props(styles.base, props.hidden && styles.hidden, style)} {...coreProps}>
      {(renderProps) => (
        <Provider values={[
          [LinkContext, {
            size: 14,
            style: linkStyles.base,
          }],
          [TextContext, {
            size: 14,
            color: 'disabled',
          }],
        ]}>
          {typeof children === 'function' ? children(renderProps) : children}
          <Text>/</Text>
        </Provider>
      )}
    </BreadcrumbCore>
  );
});

const styles = stylex.create({
  base: {
    gap: 8,
    alignItems: 'center',
    display: 'flex',
  },
  hidden: {
    display: 'none',
  },
});

const linkStyles = stylex.create({
  base: {
    color: {
      default: $.textTertiary,
      ':hover': $.textPrimary,
    },
    transitionDuration: '0.2s',
    transitionProperty: 'color',
    transitionTimingFunction: 'easy-in-out',
  },
});

export { Breadcrumb, BreadcrumbContext, type BreadcrumbProps };
